function JoyTycoonComboBox(config) {
  myPixiElement.container.call(this);


  this.config = $.extend(true,{
        img:"comboBox",
        capText:"BONUS",
        pos:[0,0],
        howmany:0,
        text_conf:{
            cap:{
                font_color:"#ffffff",
                font_size:15,
                border_color:"#3a1e0c",
                border_size:2,
                pos:[-13,8],
            },
            desc:{
                font_color:"#ffdf2c",
                font_size:36,
                border_color:"#3a1e0c",
                border_size:4,
                pos:[-13,36],
            },
        },
        onEnd:function(){
            
        }
        
  },config);
  this.x=this.config.pos[0];
  this.y=this.config.pos[1];
  this.storage={
      howmany:this.config.howmany
  };
  
  this.init();
  
}
JoyTycoonComboBox.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonComboBox.prototype = $.extend(JoyTycoonComboBox.prototype, {
    init:function(){
        var obj=new myPixiElement.img({img:this.config.img,anchor:[0.5,0]});
        this.addChild(obj);
        var textConf=this.config.text_conf.cap;
        var capText=new myPixiObj.showText(this.config.capText,{
            pos:textConf.pos,
            font_color:textConf.font_color,
            font_size:textConf.font_size,
            border_color:textConf.border_color,
            border_size:textConf.border_size,
        });
        this.addChild(capText);
        textConf=this.config.text_conf.desc;
        this.textObj=new myPixiObj.showText(this.storage.howmany,{
            pos:textConf.pos,
            font_color:textConf.font_color,
            font_size:textConf.font_size,
            border_color:textConf.border_color,
            border_size:textConf.border_size,
        });
        this.addChild(this.textObj);
    },
    addHeart:function(howmany){
        this.storage.howmany+=howmany;
        this.textObj.changeText(this.storage.howmany);
    },
    takeHeart:function(){
        return this.storage.howmany;
    },
    takeBonus:function(){
        return (100+this.storage.howmany);
    },
    takeTextPos:function(){
        var offset=this.textObj.toGlobal(new PIXI.Point(0,0));
        return [offset.x,offset.y];
    }
});

